import { render, staticRenderFns } from "./LandingPageTable.vue?vue&type=template&id=9120ac5e&scoped=true"
import script from "./LandingPageTable.vue?vue&type=script&lang=js"
export * from "./LandingPageTable.vue?vue&type=script&lang=js"
import style0 from "./LandingPageTable.vue?vue&type=style&index=0&id=9120ac5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9120ac5e",
  null
  
)

export default component.exports